export default __webpack_public_path__ + "static/media/Scheduled New Patients.749d569f.svg";